import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import AOS from "aos";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const SolutionContEims = ({
  title,
  logoSrc,
  headImgSrc,
  date,
  tags,
  aboutItem,
  aboutImg,
  effectItem,
  caseItem = [],
}) => {
  const swiperRef = useRef(null);
  const SwiperActive = caseItem.length > 3; // 슬라이드가 3개 초과일 때만 Swiper 활성화

  const handleNext = () => {
    swiperRef.current.swiper.slideNext();
  };

  const handlePrev = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // // AOS 초기화 및 리프레시
  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="content sol-content">
      <div className="sol-head">
        <div className="container">
          <div className="head-txt">
            <div className="logo-area">
              <img src={logoSrc} alt={title} />
            </div>
            <span className="title">EIMS 통합 인터페이스 관리 솔루션 </span>
            <p>
              기업의 복잡한 인터페이스를 하나의 기준으로 관리합니다. <br />
              <br></br> {date}
            </p>
            <ul className="tag-group">
              {tags.map((tag, index) => (
                <li key={index} className="tag">
                  {tag}
                </li>
              ))}
            </ul>
          </div>
          <div className="head-img">
            <img src={headImgSrc} alt={title} />
          </div>
        </div>
      </div>
      <div
        className="sol-effect "
        data-aos="fade-up"
        data-aos-easing="ease-in-out"
        data-aos-delay="500"
      >
        <div className="container">
          <div className="tit-box">
            <h3 className="title">Why EIMS? </h3>
            <span className="txt"></span>
          </div>
          <div className="top">
            <div>
              <h2 className="my-4 text-[30px]">
                복잡해지는 인터페이스, 하나의 기준으로 관리합니다
              </h2>
            </div>
            <div className="item text-[20px]">
              기업의 시스템과 연계 업무가 증가할수록 인터페이스 정보는 여러
              시스템과 문서에 분산됩니다.
              <br></br>
              인터페이스 정보의 분산은 중복 개발, 표준 불일치, 변경 영향도
              파악의 어려움, 운영 리스크 증가​로 이어질 수 있습니다.
              <br></br>
              ModelIN은 인터페이스 정보를 하나의 관리체계로 통합하여 개발부터
              변경·운영·폐기까지 일관된 EIMS 관리 환경을 제공합니다.
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="sol-about"
          data-aos="fade-up"
          data-aos-easing="ease-in-out"
          data-aos-delay="500"
        >
          <div className="tit-box">
            <h3 className="title">제품 장점</h3>
            <span className="txt">Product Advantages</span>
          </div>
          <div className="top">
            <div>
              <h2 className="my-4 text-[30px]">
                기업의 모든 인터페이스 정보를 표준화하고, 개발부터 운영까지
                하나의 EIMS 환경에서 통합 관리합니다.
              </h2>
            </div>
            <div className="item text-[20px]">
              <ul className="about-group ">
                <li className="border rounded-lg p-4 mb-4 bg-[#f8f9fa]">
                  <p className="text-[20px] font-bold">
                    인터페이스 표준화 및 개발 생산성 향상
                  </p>
                  <p className="text-[20px]">
                    표준화된 인터페이스 정의체계를 통해 일관된 개발환경을
                    제공하고 반복적인 등록·관리 업무를 줄여 개발 생산성을
                    높입니다.
                  </p>
                </li>
                <li className="border rounded-lg p-4 mb-4 bg-[#f8f9fa]">
                  <p className="text-[20px] font-bold">
                    전사 인터페이스 정보 통합·공유
                  </p>
                  <p className="text-[20px]">
                    시스템별로 분산된 인터페이스와 전문 정보를 하나의 플랫폼으로
                    통합하여 개발·운영 담당자가 동일한 정보를 공유하고 활용할 수
                    있습니다.
                  </p>
                </li>
                <li className="border rounded-lg p-4 mb-4 bg-[#f8f9fa]">
                  <p className="text-[20px] font-bold">
                    인터페이스 전 생명주기 통합 관리
                  </p>
                  <p className="text-[20px]">
                    인터페이스의 등록부터 변경, 운영, 폐기까지 전체
                    라이프사이클을 체계적으로 관리합니다.
                  </p>
                </li>
                <li className="border rounded-lg p-4 mb-4 bg-[#f8f9fa]">
                  <p className="text-[20px] font-bold">
                    변경·형상·이력 및 영향도 관리
                  </p>
                  <p className="text-[20px]">
                    전문 구조와 항목, 전문 형상, 변경이력을 체계적으로 관리하고
                    연관 정보를 추적하여 변경에 따른 영향을 신속하게 파악할 수
                    있습니다.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-box">
            <div>
              <img src={aboutImg} alt={title} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="sol-effect"
        data-aos="fade-up"
        data-aos-easing="ease-in-out"
        data-aos-delay="570"
      >
        <div className="container">
          <div className="tit-box">
            <h3 className="title">도입 효과</h3>
            <span className="txt">Introduction Effects</span>
          </div>
          <ul className="list-count">
            <li className="item">
              <span className="number">01</span>
              <span>
                <span className="font-bold">개발·유지보수 생산성 향상</span>
                <br></br>
                표준화된 인터페이스 정의와 기존 정보의 재사용, 사용자 중심의
                등록·관리 환경을 통해 신규 개발과 유지보수 업무의 생산성을
                높입니다.
              </span>
            </li>
            <li className="item">
              <span className="number">02</span>
              <span>
                <span className="font-bold">
                  표준화된 인터페이스 운영체계 확보
                </span>
                <br></br>
                분산된 인터페이스와 전문 정보를 하나의 기준으로 통합하여 일관된
                개발·운영 관리체계를 확보할 수 있습니다.
              </span>
            </li>
            <li className="item">
              <span className="number">03</span>
              <span>
                <span className="font-bold">정보 가시성 및 운영 효율 향상</span>
                <br></br>
                개별 연계 시스템을 각각 확인하지 않고 ModelIN에서 인터페이스와
                전문 정보를 통합 조회할 수 있어 변경 관리와 장애 분석의 효율성을
                높입니다.
              </span>
            </li>
            <li className="item">
              <span className="number">04</span>
              <span>
                <span className="font-bold">사용자 편의성 강화</span>
                <br></br>
                직관적인 UI·UX와 효율적인 업무 절차를 통해 반복적인 입력과
                불필요한 관리 과정을 줄이고 인터페이스 등록·관리 편의성을
                높입니다.
              </span>
            </li>
          </ul>
        </div>
      </div>

      {caseItem.length > 0 && (
        <div
          className="container"
          data-aos="fade-up"
          data-aos-easing="ease-in-out"
          data-aos-delay="600"
        >
          <div className="sol-case">
            <div className="tit-box">
              <h3 className="title">도입 사례</h3>
              <span className="txt">Introduction Case</span>
            </div>
            <div className="top">
              <div className="font-bold text-[20px]">
                금융권에서 축적한 EIMS 및 인터페이스 관리 경험을 바탕으로 다양한
                기업의 인터페이스 통합관리 환경을 구축하고 있습니다.
              </div>
            </div>
            <div className="swiper-box">
              {SwiperActive ? (
                <Swiper
                  ref={swiperRef}
                  className="swiper-sol"
                  modules={[Navigation, Pagination]}
                  loop={true}
                  // slidesPerView={3}  // 가운데 3개 슬라이드 표시
                  slidesPerView={isMobile ? 1.5 : 3} // 모바일에서는 1.5개
                  spaceBetween={20} // 슬라이드 사이 간격
                  slidesOffsetBefore={20} // 슬라이드 시작 부분 여백
                  slidesOffsetAfter={30}
                  loopAdditionalSlides={1}
                  navigation={
                    !isMobile
                      ? {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        }
                      : false
                  }
                  pagination={
                    isMobile
                      ? { el: ".swiper-pagination", clickable: true }
                      : false
                  }
                >
                  {caseItem.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="card">
                        <div className="project-img">
                          <img src={item.images} alt={item.name} />
                        </div>
                        <div className="project-txt">
                          <span className="name">{item.name}</span>
                          <p className="txt">{item.desc}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                  {isMobile && <div className="swiper-pagination"></div>}
                </Swiper>
              ) : (
                <div className="card-box">
                  {caseItem.map((item, index) => (
                    <div className="card" key={index}>
                      <div className="project-img">
                        <img src={item.images} alt={item.name} />
                      </div>
                      <div className="project-txt">
                        <span className="name">{item.name}</span>
                        <p className="txt">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {SwiperActive && (
                <>
                  <div
                    className="swiper-button-prev"
                    onClick={handlePrev}
                  ></div>
                  <div
                    className="swiper-button-next"
                    onClick={handleNext}
                  ></div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <div
        className="sol-effect"
        data-aos="fade-up"
        data-aos-easing="ease-in-out"
        data-aos-delay="570"
      >
        <div className="container">
          <div className="tit-box">
            <h3 className="title">검증된 EIMS 구축 경험으로 시작하세요</h3>
            <span className="txt">
              Enterprise Interface Management with ModelIN
            </span>
          </div>
          <div className="top mb-10">
            <div className="item text-[20px]">
              복잡하게 분산된 인터페이스와 전문 정보를 통합하고 개발과 운영을
              하나의 관리체계로 연결합니다.
            </div>
            <div className="my-4 text-[20px]">
              아이엔아이소프트는 금융권에서 축적한 인터페이스 관리 경험과 GS인증
              1등급 ModelIN을 기반으로 기업의 인터페이스 관리 표준화와 운영
              효율화를 지원합니다.
            </div>
          </div>
          <div className="flex flex-wrap gap-3 ">
            <Link
              to="/contact?type=demo&product=modelin"
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "modelin_demo_click",
                  solution: "ModelIN",
                  inquiry_type: "demo",
                  button_name: "방문 데모 신청",
                });
              }}
              href="/contact?type=demo&product=modelin"
              className="
      inline-flex items-center justify-center
      rounded-full
      bg-blue-600
         px-8 py-4
      text-lg font-semibold text-white 
      shadow-sm
      transition
      hover:bg-blue-700
      hover:shadow-md
    "
            >
              방문 데모 신청
              <span className="ml-2">→</span>
            </Link>
            <Link
              className="
      inline-flex items-center justify-center
      rounded-full
      border border-blue-200
      bg-white
           px-8 py-4
      text-lg font-semibold text-blue-700
      transition
      hover:border-blue-300
      hover:bg-blue-50
    "
              to="/contact?type=qna&product=modelin"
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "modelin_qna_click",
                  solution: "ModelIN",
                  inquiry_type: "qna",
                  button_name: "제품 문의하기",
                });
              }}
            >
              제품 문의하기
            </Link>
          </div>
        </div>
      </div>
      <div className="btn-group">
        <Link to="/solutions/solution" className="btn main">
          목록
        </Link>
      </div>
    </div>
  );
};

export default SolutionContEims;
